"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _socket = _interopRequireDefault(require("socket.io-client"));

var _rxjs = require("rxjs");

var _js = require("@agile-actors/actions/dist/js");

var _utils = require("../../dist/commons/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var noop = function noop() {};

var disconnect$ = new _rxjs.Subject();
var socket = null;
var emit = noop;
var on = noop;
var close = noop;

var actionsSocketInit = function actionsSocketInit(actionsHost, actionsSocketNamespace) {
  var _context;

  socket = (0, _socket["default"])((0, _utils.joinPaths)(actionsHost, actionsSocketNamespace), {
    transports: ['polling', 'websocket'],
    withCredentials: true
  });
  close = (_context = socket).close.bind(_context);

  emit = function emit(action) {
    return socket.emit('actions', action);
  }; // TODO: get from config


  on = function on(actionHandler) {
    return socket.on('actions', actionHandler);
  }; // TODO: get from config


  socket.emit('actions', (0, _js.socketConnected)());
  socket.on('reconnect', function () {
    console.log("*** CLIENT reconnect");
    socket.emit('client_reconnect');
  });
  socket.on('disconnect', function (reason) {
    console.log("*** CLIENT disconnect", reason);
    disconnect$.next((0, _js.socketDisconnected)(reason));
  });
};

var ActionsSocket = function ActionsSocket(actionsHost, actionsSocketNamespace) {
  if (!socket && actionsHost && actionsSocketNamespace) {
    actionsSocketInit(actionsHost, actionsSocketNamespace);
  }

  return Object.freeze({
    emit: emit,
    on: on,
    close: close,
    disconnect$: disconnect$
  });
};

var _default = ActionsSocket;
exports["default"] = _default;